var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("h1", { staticClass: "mt-2 mb-4" }, [_vm._v("Password Reset")]),
    _vm._v(" "),
    _c("div", { staticClass: "pb-20 h-screen w-full md:w-1/2" }, [
      _c(
        "form",
        {
          attrs: { method: "POST", "aria-label": "Forgot Password" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.validateBeforeSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              class: {
                "mb-8 text-left": true,
                "has-error": _vm.errors.has("email"),
              },
            },
            [
              _c(
                "label",
                {
                  ref: "email",
                  staticClass: "text-h3 font-sans-bold",
                  attrs: { for: "email" },
                },
                [_vm._v("Email Address")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: { id: "email", type: "email", name: "email" },
                domProps: { value: _vm.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.email = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("email"),
                      expression: "errors.has('email')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("email")))]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: {
                "mb-8 text-left": true,
                "has-error": _vm.errors.has("password"),
              },
            },
            [
              _c(
                "label",
                {
                  ref: "password",
                  staticClass: "text-h3 font-sans-bold",
                  attrs: { for: "password" },
                },
                [
                  _vm._v(
                    "\n                      Password\n                      "
                  ),
                  _vm._m(0),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.password,
                    expression: "password",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|min:8|upperCase|number|lowerCase",
                    expression: "'required|min:8|upperCase|number|lowerCase'",
                  },
                ],
                ref: "passwordInput",
                attrs: { id: "password", type: "password", name: "password" },
                domProps: { value: _vm.password },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.password = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("password"),
                      expression: "errors.has('password')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("password")))]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: {
                "mb-8 text-left": true,
                "has-error": _vm.errors.has("password_confirmation"),
              },
            },
            [
              _c(
                "label",
                {
                  ref: "password_confirmation",
                  staticClass: "text-h3 font-sans-bold",
                  attrs: { for: "email" },
                },
                [_vm._v("Confirm Password")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|confirmed:passwordInput",
                    expression: "'required|confirmed:passwordInput'",
                  },
                ],
                attrs: {
                  id: "password",
                  type: "password",
                  name: "password_confirmation",
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("password_confirmation"),
                      expression: "errors.has('password_confirmation')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("password_confirmation")))]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._m(1),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-sm font-sans-book" }, [
      _c("span", { staticClass: "font-sans-bold" }, [
        _vm._v(
          "Password should contain at least 8 characters, including at least 1 lowercase letter, 1 uppercase letter, and 1 number."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-left" }, [
      _c("button", { staticClass: "button", attrs: { type: "submit" } }, [
        _vm._v("\n                      Reset my password\n                  "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }